export const ENV_VARIABLES = {
  NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME ?? 'App',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
} as const;
